module.exports = __webpack_public_path__ + "img/kislovodsk-excursions.72085d70.jpg";